export const removeTrackerPopup = {
  title: '刪除此項目嗎？',
  content:
    '確定刪除？一旦刪除將無法復原<br /><checkbox>我理解刪除後將無法復原，我仍要刪除。</checkbox>',
  ok: '刪除',
  cancel: '取消',
};

export default removeTrackerPopup;
